<template>
  <v-container fluid id="tf-solution" class="tf-solution-section py-8 py-md-16">
    <v-container>

      <v-row class="mb-10">
        <v-col cols="12" class="text-center">
          <span
            class="overline font-weight-bold"
            :style="{ color: '#00695C' }"
            data-aos="fade-down"
          >
            LA SOLUCIÓN
          </span>
          <h2
            class="display-1 font-weight-bold primary--text mt-2"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            De documentos dispersos a operación controlada
          </h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          v-for="(step, i) in steps"
          :key="i"
          cols="12"
          md="4"
          data-aos="fade-up"
          :data-aos-delay="String(i * 150)"
        >
          <v-card class="tf-solution-card pa-6 h-100" elevation="2">
            <div class="d-flex align-center mb-4">
              <v-avatar
                size="56"
                :style="{ backgroundColor: step.color + '1A' }"
                class="mr-4"
              >
                <v-icon :color="step.color" size="28">
                  {{ step.icon }}
                </v-icon>
              </v-avatar>
              <span
                class="display-1 font-weight-black"
                :style="{
                  color: step.color + '33',
                  lineHeight: '1',
                }"
              >
                {{ step.number }}
              </span>
            </div>
            <h3 class="text-h6 font-weight-bold primary--text mb-3">
              {{ step.title }}
            </h3>
            <v-list dense class="transparent pa-0">
              <v-list-item
                v-for="(bullet, j) in step.bullets"
                :key="j"
                class="px-0"
                dense
              >
                <v-list-item-icon class="mr-2 my-auto">
                  <v-icon small :color="step.color">
                    mdi-check-circle
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    class="body-2 greydark--text"
                    style="white-space: normal;"
                  >
                    {{ bullet }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>

      <!-- Bottom CTA -->
      <v-row class="mt-12">
        <v-col
          cols="12"
          class="text-center"
          data-aos="fade-up"
          data-aos-delay="500"
        >
          <v-btn
            :x-large="$vuetify.breakpoint.mdAndUp"
            :large="$vuetify.breakpoint.smAndDown"
            depressed
            class="white--text"
            :style="{ backgroundColor: '#00695C' }"
            href="#tf-contact"
            rounded
          >
            Empezar Ahora — Sin Compromisos
          </v-btn>
        </v-col>
      </v-row>

    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'TFSolution',
  data() {
    return {
      steps: [
        {
          number: '01',
          icon: 'mdi-file-export',
          color: '#00695C',
          title: 'Genera documentos de embarque',
          bullets: [
            'BL, packing list y factura comercial desde una sola pantalla',
            'Plantillas configuradas para tu operación específica',
            'Envío directo al naviero y agente aduanal',
          ],
        },
        {
          number: '02',
          icon: 'mdi-currency-usd',
          color: '#FF6B35',
          title: 'Controla gastos de flete y despacho',
          bullets: [
            'Aprobaciones de cotizaciones con flujo trazable',
            'Comparativa de costos por operación y proveedor',
            'Conciliación automática contra presupuesto',
          ],
        },
        {
          number: '03',
          icon: 'mdi-robot',
          color: '#7C4DFF',
          title: 'AI valida tus documentos aduanales',
          bullets: [
            'Revisión automática de factura contra pedimento',
            'Alertas de discrepancias antes de presentar al SAT',
            'Historial de validaciones por operación',
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.tf-solution-section {
  background-color: #FFFFFF;
}

.tf-solution-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 12px;
}

.tf-solution-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 105, 92, 0.12) !important;
}

.transparent {
  background: transparent !important;
}

</style>
